import { get, post } from '@/util/request.js';

export function getConfig(payload) {
	return get('etl/config/get', payload);
}

export function createJob({ config, dryRun, runParams }) {
	return post('etl/job/create', {
		config, dryRun, runParams
	});
}

export function addDataToJob({ job, jsonData, csvData, xlsxData }) {
	return post('etl/job/adddata', { job, jsonData, csvData, xlsxData });
}

export function startJob({ job }) {
	return post('etl/job/start', { job });
}

export function getJob({ job }) {
	return post('etl/job/get', { job });
}

export async function pollUntilJobComplete(job, wait, max, onUpdate = () => {}) {
	let res;
	let success = await waitUntilTrue(async() => {
		res = await getJob({ job });
		onUpdate(res)
		return res.status === 'complete';
	}, wait, max);
	if (success) return res;
	else throw new Error('timeout');
}

function wait(ms, rej) {
	return new Promise(function(resolve, reject) {
		setTimeout(rej ? reject : resolve, ms);
	});
}

async function waitUntilTrue(fn, retry, max) {
	if (!max) max = 2000;
	if (!retry) retry = 100;
	let start = Date.now();
	do {
		let res = await fn();
		if (res) return true;
		await wait(retry);
		// console.log(Date.now() - start);
	} while (Date.now() - start < max);
	return false;
}
